var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "13px",
    width: "10.59px",
    viewBox: "0 0 10.59 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1c3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "userIconFull"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "iconHead",
    className: "cls-1",
    cx: 5.3,
    cy: 3.26,
    r: 3.26
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconBody",
    className: "cls-1",
    d: "M8.84,13H1.74C.68,13-.13,12.25,0,11.41L.76,9A1.66,1.66,0,0,1,2.49,7.77H8.1A1.66,1.66,0,0,1,9.83,9l.75,2.45C10.72,12.25,9.91,13,8.84,13Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.e6ae2acb1ea075fd8b1d9b714c2b9da4.svg";
export { ForwardRef as ReactComponent };